import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Pane, TextInputField, EyeOpenIcon, EyeOffIcon } from "evergreen-ui";
import { loginApi } from "../../../Redux/Auth/loginApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./login.css";
import { Link, useNavigate } from "react-router-dom";
import { login_success,set_user_id } from "../../../Redux/Auth/Auth.action";
import { validatePhoneNumber } from "../../../Utils/Validation";
import { IMAGE_PATH, PRODUCT } from "../../../Utils/variables";
export const Login = ({ RenderHandler }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { isLogin, vendorId } = useSelector((state) => state.auth);
  const [isvisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // ----------------email regex---------------------
  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = (e) => {
    // e.preventDefault();

    // if (validateEmail(email)) {
    //   // toast.error("Please enter valid Email Address");
    // } else {
    //   if (!validateEmail(email)) {
    //     if (!validatePhoneNumber(email)) {
    //       toast.error("Please enter valid Number or Email");
    //       return;
    //     }
    //   }
    // }

    // if (password == "") {
    //   toast.error("Please enter password");
    e.preventDefault();
    if (!validateEmail(email.trim())) {
      toast.error("Please Enter Valid Email Address");
    } else if (password == "") {
      toast.error("Please Enter Password");
    } else {
      setIsVisible(true);
      fetch(process.env.REACT_APP_API_URL + "/api/vendor/login", {
        method: "POST",
        body: JSON.stringify({ email: email, password: password }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setIsVisible(false);
          let status = res.status;
          if (status == true) {
            localStorage.clear();
            toast(`${res.message}`, {
              type: "success",
            });
            dispatch(login_success({vendorId: res.response.id, vendorName: res.response?.user[0]?.vendor_name}));
            dispatch(set_user_id(res?.response?.user[0]?.user_id));
            getAllCommunities();
            navigate("/rfqs");
          } else {
            toast(`${res.message}`, {
              type: "error",
            });
          }
        })
        .catch((err) => {
          setIsVisible(true);
          console.log("e", err);
        });
    }
  };

  const getAllCommunities = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendor/allcommunities", {
      method: "POST",
    })
      .then((d) => d.json())
      .then((res) => {
        localStorage.setItem("allCommunities", JSON.stringify(res.response));
      })
      .catch((err) => console.log("e", err));
  };

  useEffect(() => {
    if (isLogin) {
      navigate("/rfqs");
    }
    document.title = PRODUCT + " - Vendor Login";
  }, []);

  const handleShowPassword = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowPassword(prev => !prev)
  }

  return (
    <>
      <div
        className="loginMainDiv"
        style={{
          backgroundImage: `url(${IMAGE_PATH}loginLeftBg.svg),
        url(${IMAGE_PATH}loginRightBg.svg)`,
        }}
      >
        <div className="loginOuterCard">
          <h2 className="loginHeading">VENDOR LOGIN</h2>
          <form onSubmit={handleSubmit}>
            <div className="loginCardDiv">
              <TextInputField
                disabled={isvisible}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                label="Email"
                placeholder="Enter Email"
                className="inputDivLogin"
              />
              <Pane className="panecls">
              <TextInputField
                disabled={isvisible}
                type={showPassword ?"text":"password"}
                className="inputDivLogin"
                label="Password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {showPassword ? 
                <EyeOpenIcon className="eyecommon"  onClick={handleShowPassword}/>
              : <EyeOffIcon className="eyecommon" onClick={handleShowPassword}/>
              }
              </Pane>
              <div className="forget-password">
                <Link to={"/forgetpassword"}>
                  {" "}
                  <p>Forgot Password?</p>
                </Link>
              </div>
              <div>
                <Button
                  type="submit"
                  width={300}
                  height={40}
                  className={isvisible ? "login-btnDisabled" : "login-btn"}
                  id="poppinFontLogin"
                >
                  {isvisible && (
                    <i
                      className="fa fa-spinner fa-spin "
                      style={{ color: "white", marginRight: "10px" }}
                    ></i>
                  )}
                  Login
                </Button>
              </div>
              <p className="do-you-have-account">
                Don't have an account? {""}
                <span>
                  <Link to={"/createaccount"}>CREATE AN ACCOUNT</Link>
                </span>
              </p>
            </div>
          </form>

          <ToastContainer autoClose={5000} />
        </div>
      </div>
    </>
  );
};
